const __DEV__ = false;

import * as React from 'react';
import useEnhancedEffect from '../use-enhanced-effect/use-enhanced-effect.js';

function useEventCallback(fn) {
  var ref = React.useRef(fn);
  useEnhancedEffect(function () {
    ref.current = fn;
  });
  return React.useCallback(function () {
    return (
      (ref.current).apply(void 0, arguments)
    );
  }, []);
}

export { useEventCallback as default };
//# sourceMappingURL=use-event-callback.js.map
